const Title = () => {
  return (
    <div className="flex w-full items-end justify-center">
      <div className="flex items-center flex-col w-[1153px]">
        <h1 className="sm:text-6xl font-bold text-center">Key Features of Redact Enterprise</h1>
        <h2 className="text-center text-xl sm:text-3xl bg-gradient-to-r from-brand-purple to-brand-blue text-transparent bg-clip-text font-extrabold">
          E A S Y &nbsp; S T E P S &nbsp; T O &nbsp; G E T &nbsp; S T A R T E D
        </h2>
      </div>
    </div>
  );
};

export default Title;
